import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, user } = useContext(LoginContext);

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Si hay roles permitidos y el usuario no tiene uno de esos roles, redirigir
  if (allowedRoles.length > 0) {
    let userRole = (user.tiu_descripcion || '').toUpperCase();
    if (!userRole && user.usu_tipousuario === 4) userRole = 'FICHADA';
    if (!userRole && user.usu_tipousuario === 3) userRole = 'PROFESOR';
    if (!userRole && user.usu_tipousuario === 1) userRole = 'ADMINISTRADOR';
    if (!userRole && user.usu_tipousuario === 2) userRole = 'ALUMNO';
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/login" replace />;
    }
  }

  // Si está autenticado y tiene el rol correcto, renderiza los componentes hijos
  return children;
};

export default ProtectedRoute;

